import axios from "@/axios";
import store from "@/store";

const state = {
  loading: false,
};

const getters = {
  retrieveLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async addStockAlert({ commit }, prod_no) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      customerNo: this.getters.retrieveSelectedCustomer,
      prodNo: prod_no,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setLoading", true);

    const response = await axios
      .post("stockalerts/add-stock-alert", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);

        // await store.dispatch("getAllDiscounts");

        commit("setLoading", false);
        return response.data.success;
      } else {
        commit("setLoading", false);

        store.dispatch("setSnackbar", {
          color: "error",
          text: response.data.message,
        });

        return response.data.success;
      }
    } else {
      commit("setLoading", false);

      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },
};

const mutations = {
  setLoading: (state, value) => (state.loading = value),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
